import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { AttributeName } from 'cadenza/model/attribute-name.gen';
import { type RootStateOr, createSliceFunction, getStore } from 'cadenza/store/cadenza-store';

const SLICE_PREFIX = 'manageObjecttypeDialog';

interface ManageObjecttypeDialogState {
  attributeName?: AttributeName;
  multiAttributeHierarchyName?: AttributeName;
  dateHierarchyName?: AttributeName;
}

declare module 'cadenza/store/cadenza-store' {
  interface RootState {
    [SLICE_PREFIX]: ManageObjecttypeDialogState;
  }
}
const slice = createSliceFunction(SLICE_PREFIX);

const manageObjecttypeDialogSlice = createSlice({
  name: SLICE_PREFIX,
  initialState: {},
  reducers: {
    setAttributeName(state: ManageObjecttypeDialogState, payload: PayloadAction<AttributeName>) {
      state.attributeName = payload.payload;
    },
    setMultiAttributeHierarchyName(state: ManageObjecttypeDialogState, payload: PayloadAction<AttributeName>) {
      state.multiAttributeHierarchyName = payload.payload;
    },
    setDateHierarchyName(state: ManageObjecttypeDialogState, payload: PayloadAction<AttributeName>) {
      state.dateHierarchyName = payload.payload;
    },
    resetAttributeName(state: ManageObjecttypeDialogState) {
      state.attributeName = undefined;
    },
    resetInitialState(state: ManageObjecttypeDialogState) {
      state.attributeName = undefined;
      state.multiAttributeHierarchyName = undefined;
      state.dateHierarchyName = undefined;
    },
  },
});

const { reducer, actions } = manageObjecttypeDialogSlice;
getStore().registerReducer(SLICE_PREFIX, reducer);

export const {
  setAttributeName,
  setMultiAttributeHierarchyName,
  setDateHierarchyName,
  resetInitialState,
  resetAttributeName,
} = actions;

export const getAttributeName = (state: RootStateOr<ManageObjecttypeDialogState>): AttributeName | undefined =>
  slice(state).attributeName;

export const getManageObjecttypeDialogState = (
  state: RootStateOr<ManageObjecttypeDialogState>,
): ManageObjecttypeDialogState => slice(state);

export const getMultiAttributeHierarchyName = (
  state: RootStateOr<ManageObjecttypeDialogState>,
): AttributeName | undefined => slice(state).multiAttributeHierarchyName;

export const getDateHierarchyName = (state: RootStateOr<ManageObjecttypeDialogState>): AttributeName | undefined =>
  slice(state).dateHierarchyName;
